import { useQuery } from "@hooks/useQuery";
import { Icon } from "@iconify/react";
import { Button, Tabs } from "antd";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { GeoLocation } from "./GeoLocation/GeoLocation";
import { GeoLocationLevels } from "./GeoLocationLevels/GeoLocationLevels";
import { GeoLocationPromotion } from "./GeoLocationPromotion/GeoLocationPromotion";
import { NotificationType } from "./NoticationType/NotificationType";
import { MyAirportsPromotions } from "./Promotions/Promotion";
import { RepeatType } from "./RepeatType/RepeatType";

export const MyAirportsPromotionsManagement = () => {
  const query = useQuery();
  const navigate = useNavigate();

  const activeTab = query.get("activeTab");

  useEffect(() => {
    if (query.get("id")) {
      return;
    }
    if (!activeTab) {
      navigate(`/centralized/centralizedPromotion?activeTab=notificationType`, {
        replace: true,
      });
    }
  }, [query.get("activeTab")]);

  const tabItems = [
    {
      label: "Notification Type",
      key: "notificationType",
      children: <NotificationType />,
    },
    {
      label: "Repeat Type",
      key: "repeatType",
      children: <RepeatType />,
    },
    {
      label: "Promotions",
      key: "promotion",
      children: <MyAirportsPromotions />,
    },
    {
      label: "Geo Location Promotions",
      key: "geoLocationPromotions",
      children: <GeoLocationPromotion />,
    },
    {
      label: "Geo Location Promotion Levels",
      key: "geoLocationPromotionLevels",
      children: <GeoLocationLevels />,
    },
    {
      label: "Geo Location Offer Details",
      key: "geoLocationOffer",
      children: <GeoLocation />,
    },
  ];

  const handleMyairports = (activeTab: any) => {
    if (activeTab === "notificationType") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedPromotion/notificationType/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Notification Type
        </Button>
      );
    }
    if (activeTab === "repeatType") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedPromotion/repeatType/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Repeat Type
        </Button>
      );
    }
    if (activeTab === "promotion") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedPromotion/promotion/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Promotions
        </Button>
      );
    }
    if (activeTab === "geoLocationPromotions") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedPromotion/geoLocationPromotions/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Geo Location Promotions
        </Button>
      );
    }
    if (activeTab === "geoLocationPromotionLevels") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedPromotion/geoLocationPromotionLevels/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Geo Location Promotion Levels
        </Button>
      );
    }
    if (activeTab === "geoLocationOffer") {
      return (
        <Button
          onClick={() => {
            navigate("/centralized/centralizedPromotion/geoLocationOffer/add");
          }}
          icon={<Icon icon={"lucide:plus"} />}
        >
          Add Geo Location Offer Details
        </Button>
      );
    }
  };

  const airportTextMap: Record<string, string> = {
    notificationType: "MyAirports",
    repeatType: "MyAirports",
    promotion: "MyAirports, Eraman and Passenger",
    geoLocationPromotions: "MyAirports",
    geoLocationPromotionLevels: "MyAirports",
    geoLocationOffer: "MyAirports",
  };

  const airportText = airportTextMap[activeTab || "notificationType"];

  return (
    <ContentWrapper
      title="Promotions"
      bodyStyle={{ height: "calc(100vh - 100px)", overflowY: "auto" }}
      actionItems={handleMyairports(query.get("activeTab"))}
      airportText={airportText}
    >
      <Tabs
        activeKey={query?.get("activeTab") || ""}
        items={tabItems}
        onChange={(activeKey) => {
          navigate(`${window.location.pathname}?activeTab=${activeKey}`);
        }}
      />
    </ContentWrapper>
  );
};
